/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentCompanyUser
 */
export interface CurrentCompanyUser {
    /**
     * 企業ID
     * @type {number}
     * @memberof CurrentCompanyUser
     */
    companyId: number;
    /**
     * 企業名
     * @type {string}
     * @memberof CurrentCompanyUser
     */
    companyName: string;
    /**
     * ファイルリソースが保存されたオンプレのURL
     * @type {string}
     * @memberof CurrentCompanyUser
     */
    companyLogoUrl: string | null;
    /**
     * ユーザーID
     * @type {number}
     * @memberof CurrentCompanyUser
     */
    companyUserId: number;
    /**
     * 個人事業主フラグ
     * @type {boolean}
     * @memberof CurrentCompanyUser
     */
    isSoleProprietorship: boolean;
    /**
     * 担当者の苗字（本当はlast_name）
     * @type {string}
     * @memberof CurrentCompanyUser
     */
    firstName: string;
    /**
     * 担当者の名前（本来はfirst_name）
     * @type {string}
     * @memberof CurrentCompanyUser
     */
    lastName: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof CurrentCompanyUser
     */
    mail: string;
    /**
     * メインユーザー
     * @type {boolean}
     * @memberof CurrentCompanyUser
     */
    isMain: boolean;
    /**
     * リリース配信権限ありユーザー
     * @type {boolean}
     * @memberof CurrentCompanyUser
     */
    isReleasable: boolean;
    /**
     * 企業が登録しているプラン名
     * @type {string}
     * @memberof CurrentCompanyUser
     */
    planName: string;
    /**
     * 企業が当日にリリースを作成しているかどうか
     * @type {boolean}
     * @memberof CurrentCompanyUser
     */
    existsTodayRelease: boolean;
    /**
     * Xへのプレスリリースの投稿が許可されているかどうか
     * @type {boolean}
     * @memberof CurrentCompanyUser
     */
    xPostAllowFlag: boolean;
    /**
     * Facebookへのプレスリリースの投稿が許可されているかどうか
     * @type {boolean}
     * @memberof CurrentCompanyUser
     */
    facebookPostAllowFlag: boolean;
}

/**
 * Check if a given object implements the CurrentCompanyUser interface.
 */
export function instanceOfCurrentCompanyUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "companyLogoUrl" in value;
    isInstance = isInstance && "companyUserId" in value;
    isInstance = isInstance && "isSoleProprietorship" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "mail" in value;
    isInstance = isInstance && "isMain" in value;
    isInstance = isInstance && "isReleasable" in value;
    isInstance = isInstance && "planName" in value;
    isInstance = isInstance && "existsTodayRelease" in value;
    isInstance = isInstance && "xPostAllowFlag" in value;
    isInstance = isInstance && "facebookPostAllowFlag" in value;

    return isInstance;
}

export function CurrentCompanyUserFromJSON(json: any): CurrentCompanyUser {
    return CurrentCompanyUserFromJSONTyped(json, false);
}

export function CurrentCompanyUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentCompanyUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'companyLogoUrl': json['company_logo_url'],
        'companyUserId': json['company_user_id'],
        'isSoleProprietorship': json['is_sole_proprietorship'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'mail': json['mail'],
        'isMain': json['is_main'],
        'isReleasable': json['is_releasable'],
        'planName': json['plan_name'],
        'existsTodayRelease': json['exists_today_release'],
        'xPostAllowFlag': json['x_post_allow_flag'],
        'facebookPostAllowFlag': json['facebook_post_allow_flag'],
    };
}

export function CurrentCompanyUserToJSON(value?: CurrentCompanyUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'company_name': value.companyName,
        'company_logo_url': value.companyLogoUrl,
        'company_user_id': value.companyUserId,
        'is_sole_proprietorship': value.isSoleProprietorship,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'mail': value.mail,
        'is_main': value.isMain,
        'is_releasable': value.isReleasable,
        'plan_name': value.planName,
        'exists_today_release': value.existsTodayRelease,
        'x_post_allow_flag': value.xPostAllowFlag,
        'facebook_post_allow_flag': value.facebookPostAllowFlag,
    };
}

